import { useState, useEffect } from "react";
export const useIsVisible = (element, visibilityOffset = "50px") => {
    const [isVisible, setState] = useState(false);
    useEffect(() => {
        const elm = element.current;
        const observer = new IntersectionObserver(([entry]) => {
            setState(entry.isIntersecting);
        }, { rootMargin: visibilityOffset });
        if (elm) {
            observer.observe(elm);
        }
        return () => {
            if (elm) {
                observer.unobserve(elm);
            }
        };
    }, [element, visibilityOffset]);
    return isVisible;
};
//# sourceMappingURL=useIsVisible.hooks.js.map